export default () => {

  const n = {};
  const init = () => {
    console.log('init newsSec');
    n.root = document.getElementById('news');
    if (!n.root) {
      return;
    }

    // [datetime]はMT側で設定される項目：ローカルでは未定義のため、is-newを付与
    // [datetime]を持つ要素が存在するかどうかで処理が実行
    n.articleDatetimes = n.root.querySelectorAll('.hm-news-card__date[datetime]');
    if (n.articleDatetimes.length > 0) {
      setArticleNewIcon();
    }
  }

  // 投稿から3日前までの記事に対して 「NEW」アイコンを付与
  const setArticleNewIcon = () => {
    const currentDateTime = Date.now();
    const LIMIT_RANGE = 3;
    const limitDatetime = currentDateTime - (LIMIT_RANGE * 24 * 60 * 60 * 1000);
    n.articleDatetimes.forEach(dateEle => {
      const postedDatetime = new Date(dateEle.getAttribute('datetime')).getTime();
      if (postedDatetime > limitDatetime) {
        dateEle.classList.add('is-new');
      }
    });
  }

  init();

  return {}
}
